import React, { useState } from 'react';

const ReconciliationModal = ({ transfer, onSave, onCancel, error }) => {
  const [receivedItems, setReceivedItems] = useState(
    transfer.items.map(item => ({
      product: item.product,
      name: item.name,
      quantityShipped: item.quantityShipped,
      quantityReceived: item.quantityShipped, // Default to the shipped quantity
    }))
  );
  const [discrepancyNotes, setDiscrepancyNotes] = useState('');

  const handleQuantityChange = (productId, value) => {
    const newQuantity = Math.max(0, parseInt(value) || 0);
    setReceivedItems(
      receivedItems.map(item =>
        item.product === productId ? { ...item, quantityReceived: newQuantity } : item
      )
    );
  };

  const handleAccept = () => {
    onSave({
      receivedItems: receivedItems.map(({ product, quantityReceived }) => ({ product, quantityReceived })),
      discrepancyNotes,
      isRejected: false,
    });
  };

  const handleReject = () => {
    if (window.confirm('Are you sure you want to reject this entire transfer? The stock will need to be returned to the sender.')) {
      onSave({
        receivedItems: [],
        discrepancyNotes: discrepancyNotes || 'Transfer Rejected',
        isRejected: true,
      });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl">
        <h2 className="text-2xl font-bold mb-2">Receive Stock Transfer</h2>
        <p className="text-sm text-gray-600 mb-4">Transfer ID: {transfer.transferId} from {transfer.fromStore.name}</p>
        {error && <p className="bg-red-100 text-red-700 p-3 rounded mb-4">{error}</p>}
        
        <div className="space-y-2 max-h-64 overflow-y-auto border-t border-b py-4">
          {receivedItems.map(item => (
            <div key={item.product} className="grid grid-cols-3 gap-4 items-center">
              <div>
                <p className="font-semibold">{item.name}</p>
                <p className="text-sm text-gray-500">Expected: {item.quantityShipped}</p>
              </div>
              <label className="text-sm font-medium text-gray-700">Quantity Received:</label>
              <input
                type="number"
                value={item.quantityReceived}
                onChange={(e) => handleQuantityChange(item.product, e.target.value)}
                className="p-2 border rounded-md w-full"
              />
            </div>
          ))}
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">Notes (for discrepancies or rejection)</label>
          <textarea
            value={discrepancyNotes}
            onChange={(e) => setDiscrepancyNotes(e.target.value)}
            rows="2"
            className="mt-1 p-2 border rounded-md w-full"
          />
        </div>

        <div className="flex justify-between items-center pt-6 border-t mt-6">
          <button onClick={handleReject} className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700">
            Reject Transfer
          </button>
          <div className="space-x-3">
            <button type="button" onClick={onCancel} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md">Cancel</button>
            <button onClick={handleAccept} className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark">
              Accept & Finalize
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReconciliationModal;
